import { render, staticRenderFns } from "./StickyHeader.vue?vue&type=template&id=083d4a64&scoped=true&"
import script from "./StickyHeader.vue?vue&type=script&lang=js&"
export * from "./StickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeader.vue?vue&type=style&index=0&id=083d4a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d4a64",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/StickyHeader.vue
// module id = null
// module chunks = 